function moveToHashAfterLoading() {
  const hash = window.location.hash;

  if (!hash) return;

  const target = document.querySelector(hash);
  if (!target) return;

  // 初期表示時の自動スクロールを止める
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  // ブラウザの自動ジャンプを打ち消す
  window.scrollTo(0, 0);

  const scrollToTarget = () => {
    const targetTop =
      target.getBoundingClientRect().top + window.pageYOffset - 50;

    window.scrollTo({
      top: targetTop,
      left: 0,
      behavior: "smooth",
    });
  };

  // ローディング完了後に移動
  $(window).one("loading", () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        scrollToTarget();
      });
    });
  });
}
